export default function Intro() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-20">
      <header className="mb-12 text-center">
        <h1 className="mb-4 text-4xl font-extrabold leading-tight md:text-5xl">
          Üdvözöljük a&nbsp;
          <span className="text-primary">Balaton&nbsp;Táncegyüttes</span>&nbsp;
          honlapján!
        </h1>
        <img
          src="/images/BTE_LOGO.jpg"
          alt="Balaton Táncegyüttes logó"
          className="mx-auto h-28 w-auto"
        />
      </header>

      <div className="grid gap-10 md:grid-cols-[3fr_2fr]">
        <article className="prose prose-lg max-w-none text-justify">
          <p>
            A <strong>Balaton Táncegyüttes</strong> a Dunántúl egyik kiemelkedőbb és legnagyobb múltú együttese. 
            1963-ban olyan neves folkloristák alapították, mint Együd Árpád. 
            A Táncegyüttes 2023-ban ünnepelte fennállásának 60. évfordulóját.
          </p>
          <br></br>
          <p>
            Tagjai olyan fiatalok, akik szabad idejüket a Kárpát-medence néptánc kultúrájának megismerésére, 
            továbbadására, közvetítésére és megélésére áldozzák. Az Együttesnek mindig meghatározó szerepe volt a 
            Balaton déli partján a néptánc hagyományok továbbéltetésében. Ezt mutatja az is, 
            hogy a Siófokon működő művészeti iskola tanulóinak mindenkori célja a felnőtt csoporthoz való tartozás.
          </p>
          <br></br>
          <p>
            A Balaton Táncegyüttes műsorában megtalálható a magyar táncdialektus számos gyöngyszeme. 
            Neves és tehetséges fiatal koreográfusok közvetítésével színvonalasan állítják színpadra 
            az autentikus néptánc hagyományokat. Műsoraikkal számos kiemelkedő sikert arattak már a 
            mindig nagyszámú nézők örömére, belföldön és külföldön egyaránt.
          </p>
          <br></br>
          <p>
            Minden évben önálló esten mutatják be új koreográfiáikat, műsorukat és e mellett rendszeresen 
            kitűznek magunknak egy-egy országos rangú fesztivált, megmérettetést melyekre teljes 
            erőbedobással készülnek (pl. Országos Minősítő Fesztivál, Szekszárdi Néptáncfesztivál). 
            A csoportos versenyek mellett táncosaik rendszeres résztvevői különböző szólótánc fesztiváloknak is, 
            ahonnét sosem távoznak üres kézzel.
          </p>
          <br></br>
          <p>
            Somogy Vármegye Közgyűlése 2022-ben Somogyi Érték Díjjal, 2023-ban Örökségünk - 
            Somogyország Kincse Címmel ismerte el munkájukat. 2023-ban a Néptáncosok Területi 
            Bemutató Színpada Minősítő Fesztiválon Kiemelt Nívódíjas Együttes címet érdemeltek ki. 
            2024-ben résztvevői lehettek az Országos Néptáncantológiának és az ország egyik 
            legrangosabb szakmai fesztiválján, a Szekszárdi Néptáncfesztiválon mind két bemutatott 
            produkciójuk Koreográfiai Nívódíjat, az együttes pedig a fesztivál I. helyezett Nívódíjas Együttes címet nyerte el. 
            Az előző év sikereinek eredménye, hogy ismét beválogatták az együttest 2025-ös Országos 
            Néptáncantológiára. Szintén ebben az évben, a Néptáncosok Országos Bemutató Színpada 
            Minősítő Fesztiválon a Balaton Táncegyüttes kiválóan minősült.
          </p>
          <br></br>
          <p>
            2025. punkösdjén Siófok Város Önkormányzata Siófok Turizmusáért díjban részesítette a 
            Táncegyüttest fenntartó Balaton Tánc Egyesületet.
          </p>
          <br></br>
          <p>
            Táncosaik küldetésüknek érzik, hogy a néptánc és népzene ne csak réteg kultúra legyen, 
            hanem minden magyar ember közös kultúrája, ne egy divatjelenség, hanem közös 
            táncos és zenei anyanyelv. Hiszik, hogy hagyományaink által erős közösség jön 
            létre, örök barátságok kötődnek, melyek akár több generáción átívelnek. 
            Közösségük ereje és összetartása meghatározza a mindenkori Balaton Táncegyüttest.
          </p>
          <br></br>
          <p>
            2019-től az Együttes saját nevelésű művészeti vezetőkkel büszkélkedhet, kiknek szakmai 
            munkáját az autentikus folklór mély ismerete, a táncosok magas tánctechnikai fejlesztése, 
            folklór és táncszínházi darabok készítése jellemzi, melynek alapja minden esetben a 
            tiszta forrás. Céljuk, hogy táncosainkkal bármerre is járjanak, méltón képviseljék városukat és a Balaton nevet.
          </p>
          <br></br>
          <p>
            Művészeti vezetők Fodor Janka és Csuti Péter.
          </p>
          </article>

          <div className="grid h-fit grid-cols-2 grid-rows-2 gap-4">
          <img
            src="/images/image18.jpg"
            alt=""
            className="col-span-2 h-60 w-full rounded-xl object-cover md:h-[420px]"
          />
          <img
            src="/images/image16.jpg"
            alt=""
            className="col-span-2 h-60 w-full rounded-xl object-cover md:h-[420px]"
          />
          <img
            src="/images/image22.jpg"
            alt=""
            className="col-span-2 h-60 w-full rounded-xl object-cover md:h-[420px]"
          />
        </div>
      </div>
    </section>
  );
}
